// extracted by mini-css-extract-plugin
export var container = "index-module--container--38-sb";
export var subscribeForm = "index-module--subscribeForm--N7nn0";
export var title = "index-module--title--3Pk3Y";
export var message = "index-module--message--JqaCq";
export var optOutText = "index-module--optOutText--2cSq-";